import React from 'react';
import PropTypes from 'prop-types';

export const REFERRAL_STATUS_COLOR_MAP = {
  new: '#2563eb',
  'referral accepted': '#7c3aed',
  'waiting for auth': '#0891b2',
  '1st contact': '#15803d',
  '1st contact attempt': '#15803d',
  '2nd contact attempt': '#d97706',
  '3rd contact attempt': '#b91c1c',
  scheduled: '#0f766e',
  'mohs scheduled': '#0f766e',
  completed: '#166534',
  'patient declined to schedule': '#b45309',
  'did not answer': '#dc2626',
  'no status': '#6b7280',
};

export const REFERRAL_STATUS_COLOR_FALLBACKS = [
  '#2563eb',
  '#7c3aed',
  '#0891b2',
  '#15803d',
  '#d97706',
  '#b91c1c',
];

const normalizeStatusName = (status) => String(
  typeof status === 'string' ? status : status?.name || '',
).trim().toLowerCase();

export const getReferralStatusColor = (status, statuses = [], fallbackIndex = 0) => {
  const normalizedName = normalizeStatusName(status);

  if (REFERRAL_STATUS_COLOR_MAP[normalizedName]) {
    return REFERRAL_STATUS_COLOR_MAP[normalizedName];
  }

  const matchingStatusIndex = Array.isArray(statuses)
    ? statuses.findIndex((candidate) => normalizeStatusName(candidate) === normalizedName)
    : -1;

  const resolvedIndex = matchingStatusIndex >= 0 ? matchingStatusIndex : fallbackIndex;
  return REFERRAL_STATUS_COLOR_FALLBACKS[resolvedIndex % REFERRAL_STATUS_COLOR_FALLBACKS.length];
};

const buildStatusLabel = (status, inactive) => {
  const name = typeof status === 'string' ? status : status?.name || '';

  if (inactive) {
    return `${name} (Deactivated)`;
  }

  return name;
};

export const ReferralStatusLabel = ({
  status,
  statuses,
  fallbackIndex,
  inactive,
  showDot,
}) => {
  const color = getReferralStatusColor(status, statuses, fallbackIndex);
  const label = buildStatusLabel(status, inactive);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: 0,
        color: inactive ? '#999' : 'inherit',
      }}
    >
      {showDot && (
        <span
          aria-hidden="true"
          style={{
            width: '8px',
            height: '8px',
            minWidth: '8px',
            borderRadius: '999px',
            backgroundColor: inactive ? '#cbd5e1' : color,
          }}
        />
      )}
      <span style={{ minWidth: 0 }}>{label}</span>
    </span>
  );
};

ReferralStatusLabel.defaultProps = {
  statuses: [],
  fallbackIndex: 0,
  inactive: false,
  showDot: true,
};

ReferralStatusLabel.propTypes = {
  status: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ]).isRequired,
  statuses: PropTypes.array,
  fallbackIndex: PropTypes.number,
  inactive: PropTypes.bool,
  showDot: PropTypes.bool,
};
